function timer() {
  let runs = 0;
  const typesOfRuns = /* @__PURE__ */new Set(),
    timings = {};
  function print() {
    const typeRuns = runs / typesOfRuns.size;
    let totalTime = 0;
    const out = [`Ran ${typeRuns} per-type, ${runs} total`, ...[...typesOfRuns].map(name => {
      if (name.endsWith("(ignore)")) return;
      const avg = `avg ${`${timings[name] / typeRuns}`.slice(0, 9).padEnd(9)}ms`,
        total = timings[name];
      return totalTime += total, `${name.slice(0, 30).padStart(31)} | ${avg} | total ${total}ms`;
    }), `                                    total ${totalTime}ms`].join(`
`);
    return console.info(out), out;
  }
  return {
    start(opts) {
      const quiet = opts?.quiet ?? !0;
      function time(strings, ...vars) {
        const elapsed = performance.now() - start,
          tag = templateToString(strings, ...vars);
        if (typesOfRuns.add(tag), runs++, timings[tag] ??= 0, timings[tag] += elapsed, !quiet) {
          let result = "";
          strings.forEach((str, i) => {
            result += `${str}${i === strings.length - 1 ? "" : vars[i]}`;
          }), console.info(`${`${elapsed}ms`.slice(0, 6).padStart(7)} |`, result);
        }
        start = performance.now();
      }
      let start = performance.now();
      return time.print = print, time;
    },
    profile() {
      return {
        timings,
        runs
      };
    },
    print
  };
}
function templateToString(strings, ...vars) {
  return strings.reduce((result, str, i) => result + str + (vars[i] !== void 0 ? vars[i] : ""), "");
}
export { timer };
//# sourceMappingURL=index.mjs.map
